<!-- Displayed image -->
<img
  [src]="displayedImageUrl"
  [style.transform]="'rotate(' + rotation + ')'"
  class="changeable-image"
>

<!-- Image selector button -->
<button
  (click)="onSelectImageButtonClick()"
>
  <img
    [src]="iconImageUrl"
    class="icon-image"
  />
</button>

<!-- File input -->
<input
  #fileInput
  type="file"
  [accept] = "acceptableFileTypes | joinArrayString: ','"
/>